/* Muscleshock Produktseiten 2026-10 (msp) – Claude */
(function () {
  'use strict';
  if (window.__mspInit) return; window.__mspInit = true;

  var de = function (n, dec) {
    return Number(n).toLocaleString('de-DE', { minimumFractionDigits: dec || 0, maximumFractionDigits: dec || 0 });
  };
  var eur = function (cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Zahlen hochzählen ---------- */
  function countTo(el, to, dec) {
    var token = (el.__mspTok = (el.__mspTok || 0) + 1);
    if (reduce) { el.firstChild.nodeValue = de(to, dec); el.setAttribute('data-from', to); return; }
    var cur = parseFloat(el.getAttribute('data-cur') || el.getAttribute('data-from') || '0');
    var start = null, dur = 900;
    function step(ts) {
      if (token !== el.__mspTok) return;
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var e = 1 - Math.pow(1 - p, 3), val = cur + (to - cur) * e;
      el.firstChild.nodeValue = de(val, dec);
      el.setAttribute('data-cur', val);
      if (p < 1) requestAnimationFrame(step); else el.setAttribute('data-from', to);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Sichtbarkeit (Reveal, Zähler, Balken, Skala) ---------- */
  function onSeen(el) {
    if (el.hasAttribute('data-msp-reveal')) el.classList.add('is-in');
    if (el.hasAttribute('data-msp-count')) {
      countTo(el, parseFloat(el.getAttribute('data-to')), parseInt(el.getAttribute('data-dec') || '0', 10));
    }
    $$('[data-w]', el).forEach(function (b) { b.style.width = b.getAttribute('data-w') + '%'; });
    if (el.hasAttribute('data-w')) el.style.width = el.getAttribute('data-w') + '%';
    $$('[data-left]', el).forEach(function (m) { m.style.left = m.getAttribute('data-left') + '%'; });
  }
  var seenEls = $$('[data-msp-reveal],[data-msp-count],[data-msp-bars],[data-msp-scale]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { onSeen(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    seenEls.forEach(function (el) { io.observe(el); });
  } else { seenEls.forEach(onSeen); }

  /* ---------- Umschalter (z. B. Wasser / Milch) ---------- */
  $$('[data-msp-modes]').forEach(function (box) {
    var btns = $$('[data-mode]', box);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var mode = b.getAttribute('data-mode');
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-v-' + mode + ']', box).forEach(function (v) {
          var to = parseFloat(v.getAttribute('data-v-' + mode));
          v.setAttribute('data-to', to);
          countTo(v, to, parseInt(v.getAttribute('data-dec') || '0', 10));
        });
        $$('[data-show-mode]', box).forEach(function (s) { s.hidden = s.getAttribute('data-show-mode') !== mode; });
      });
    });
  });

  /* ---------- Eiweiß-Rechner ---------- */
  $$('[data-msp-protein]').forEach(function (box) {
    var r = box.querySelector('input[type=range]');
    var perShake = parseFloat(box.getAttribute('data-per-shake'));
    var perMilk = parseFloat(box.getAttribute('data-per-milk') || '0');
    var kgOut = box.querySelector('[data-kg]'), rangeOut = box.querySelector('[data-need]'),
      pctOut = box.querySelector('[data-pct]'), pctmOut = box.querySelector('[data-pctm]'), meter = box.querySelector('[data-meter]');
    function upd() {
      var kg = parseInt(r.value, 10);
      var lo = Math.round(kg * 1.4), hi = Math.round(kg * 2.0);
      var pct = Math.round(perShake / ((lo + hi) / 2) * 100);
      kgOut.textContent = kg;
      rangeOut.textContent = lo + '–' + hi;
      pctOut.textContent = pct;
      if (pctmOut && perMilk) pctmOut.textContent = Math.round(perMilk / ((lo + hi) / 2) * 100);
      meter.style.width = Math.min(100, pct) + '%';
      r.setAttribute('aria-valuetext', kg + ' Kilogramm');
    }
    r.addEventListener('input', upd); upd();
  });

  /* ---------- Mythos-Karten ---------- */
  $$('.msp-flip').forEach(function (c) {
    c.addEventListener('click', function () {
      var on = !c.classList.contains('is-flipped');
      c.classList.toggle('is-flipped', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  });

  /* ---------- Hotspots ---------- */
  $$('[data-msp-hs]').forEach(function (box) {
    var dots = $$('.msp-hs__dot', box), lis = $$('.msp-hs__list li', box);
    function on(i) {
      dots.forEach(function (d) { d.setAttribute('aria-pressed', d.getAttribute('data-i') === i ? 'true' : 'false'); });
      lis.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('data-i') === i); });
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { on(d.getAttribute('data-i')); }); });
    lis.forEach(function (l) { l.addEventListener('mouseenter', function () { on(l.getAttribute('data-i')); }); });
  });

  /* ---------- Versand-Countdown (Europe/Berlin, Feiertage BW) ---------- */
  function berlinNow() {
    var parts = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
    var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, min: +o.minute };
  }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, mo - 1, da);
  }
  var DAY = 864e5;
  function holidays(y) {
    var e = easter(y);
    return [Date.UTC(y, 0, 1), Date.UTC(y, 0, 6), e - 2 * DAY, e + DAY, Date.UTC(y, 4, 1), e + 39 * DAY, e + 50 * DAY, e + 60 * DAY,
      Date.UTC(y, 9, 3), Date.UTC(y, 10, 1), Date.UTC(y, 11, 25), Date.UTC(y, 11, 26)];
  }
  function isWorkday(t) {
    var wd = new Date(t).getUTCDay();
    if (wd === 0 || wd === 6) return false;
    return holidays(new Date(t).getUTCFullYear()).indexOf(t) === -1;
  }
  var WD = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  $$('[data-msp-ship]').forEach(function (box) {
    var cutoff = parseInt(box.getAttribute('data-cutoff') || '10', 10);
    var out = box.querySelector('[data-ship-text]');
    function upd() {
      var n = berlinNow(), today = Date.UTC(n.y, n.m - 1, n.d), mins = n.h * 60 + n.min, left = cutoff * 60 - mins;
      if (isWorkday(today) && left > 0) {
        var hh = Math.floor(left / 60), mm = left % 60;
        out.innerHTML = 'Bestellst du in <b>' + (hh ? hh + ' Std. ' : '') + mm + ' Min.</b>, geht dein Paket <b>heute</b> noch raus.';
        return;
      }
      var t = today + DAY, guard = 0;
      while (!isWorkday(t) && guard++ < 10) t += DAY;
      var dd = new Date(t), label;
      if (t - today === DAY) label = '<b>morgen</b>';
      else label = 'am <b>' + WD[dd.getUTCDay()] + ' (' + ('0' + dd.getUTCDate()).slice(-2) + '.' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '.)</b>';
      out.innerHTML = 'Bestellst du jetzt, geht dein Paket ' + label + ' raus.';
    }
    upd(); setInterval(upd, 30000);
  });

  /* ---------- Gratis-Versand-Fortschritt ---------- */
  var freeBoxes = $$('[data-msp-free]');
  function refreshFree() {
    if (!freeBoxes.length) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        freeBoxes.forEach(function (box) {
          var th = parseInt(box.getAttribute('data-threshold'), 10), txt = box.querySelector('[data-free-text]'), bar = box.querySelector('.mspb-free__bar span');
          var tot = cart.total_price || 0;
          if (tot <= 0) { txt.innerHTML = 'Ab <b>' + eur(th) + '</b> versandkostenfrei.'; bar.style.width = '0%'; }
          else if (tot >= th) { txt.innerHTML = '<b>Dein Versand ist kostenlos.</b>'; bar.style.width = '100%'; }
          else { txt.innerHTML = 'Noch <b>' + eur(th - tot) + '</b> bis zum kostenlosen Versand.'; bar.style.width = Math.round(tot / th * 100) + '%'; }
        });
      }).catch(function () {});
  }
  refreshFree();
  ['cart:updated', 'cart:build', 'ajaxProduct:added', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refreshFree, 600); });
  });
  document.addEventListener('submit', function (e) {
    var f = e.target; if (f && f.action && f.action.indexOf('/cart/add') > -1) setTimeout(refreshFree, 1500);
  }, true);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshFree(); });

  /* ---------- Schnell in den Warenkorb (Cross-Sell) ---------- */
  $$('[data-msp-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-msp-add'), label = btn.innerHTML;
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function (data) {
          btn.classList.add('is-done'); btn.innerHTML = 'Im Warenkorb ✓';
          var item = data && data.items ? data.items[0] : data;
          try {
            if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
            if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
            document.dispatchEvent(new CustomEvent('cart:build'));
          } catch (e) {}
          refreshFree();
          setTimeout(function () { btn.disabled = false; btn.classList.remove('is-done'); btn.innerHTML = label; }, 2600);
        })
        .catch(function () { btn.disabled = false; window.location.href = '/cart/add?id=' + id + '&quantity=1'; });
    });
  });
  /* ---------- Sticky-Kaufleiste bleibt bei offenem Warenkorb nutzbar (Leo 04.10.2026) ----------
     Nach dem ersten „In den Warenkorb“ öffnet sich der Warenkorb (UpCart). Sein dunkler Hintergrund lag über der
     Sticky-Leiste: Ein Klick auf „In den Warenkorb“ schloss nur den Warenkorb, statt ein weiteres Stück hinzuzufügen.
     Jetzt liegt die Leiste neben dem offenen Warenkorb obenauf, und ein Klick legt +1 in den Warenkorb. */
  (function () {
    var bar = document.querySelector('[data-msxt-sticky]');
    var stickyBtn = bar && bar.querySelector('[data-msxt-sticky-atc]');
    if (!stickyBtn) return;
    function backdropEl() { return document.getElementById('UpcartPopupBackDrop'); }
    function backdropOpen() {
      var b = backdropEl();
      if (!b || !/active/i.test(b.className)) return false;
      var cs = getComputedStyle(b);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05;
    }
    function drawerLeft() {
      var d = document.querySelector('.upcart-cart');
      if (!d) return window.innerWidth;
      var r = d.getBoundingClientRect();
      return Math.max(0, Math.min(window.innerWidth, r.left));
    }
    function lift() {
      var left = drawerLeft();
      var on = backdropOpen() && bar.classList.contains('show') && left > 260;
      bar.classList.toggle('msp-sticky-over', on);
      bar.style.right = on ? (window.innerWidth - left) + 'px' : '';
      bar.style.zIndex = on ? '2147483641' : '';
    }
    setInterval(lift, 300);
    window.addEventListener('resize', lift);
    document.addEventListener('click', function (e) {
      var b = backdropEl();
      if (!b || !backdropOpen() || !bar.classList.contains('show') || stickyBtn.disabled) return;
      if (!(e.target === b || b.contains(e.target))) return;
      var r = stickyBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        stickyBtn.click();
      }
    }, true);
    stickyBtn.addEventListener('click', function () {
      setTimeout(function () { try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (err) {} }, 900);
    });
  })();
})();
